import { useParticleEmbeddedImage } from '../features/ttqib/useParticleEmbeddedImage';
import { TtqibEmbeddedImage } from '../features/ttqib/TtqibEmbeddedImage';
import type { OffscreenQueueItem } from '../utils/offscreenQueueFromParticles';

/** Reuse the particle service's crop and signed-asset resolver rather than copying image bytes. */
export function OsrSourceImage({card}:{card:OffscreenQueueItem}) {
 const {data,loading}=useParticleEmbeddedImage(card.particleId);
 const crop=data?.crop||card.sourceImage;
 if(crop)return <TtqibEmbeddedImage record={crop} ossId={data?.ossId} height={180} zoomable={false} />;
 if(loading)return <div role="status" className="mx-auto h-20 w-40 animate-pulse rounded-lg bg-border/30">加载来源图片…</div>;

 return null;
}
